<template>
  <div>
    <div class="kpList">
      <div>
        <div name="fade">
          <div class="kpBox" v-if="cjyhShow">
            <div>
              <div class="kpHead">
                <div>
                  <img src="@/assets/indexImg/cjyh.png" alt="安徽继续教育网" />
                </div>
                <div class="kp1">猜你想问</div>
              </div>

              <div class="kp2" v-for="(item,index) in cjyh" :key="item.id" @click="showCjyh(item)">{{index+1}}.{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div name="fade">
          <div class="kpBox1" v-if="!cjyhShow">
            <div class="back" @click="cjyhShow = true">
              <div class="fleoa">
                <img class="leftImg" src="@/assets/indexImg/left_back.png" alt="安徽继续教育网" />
              </div>
              <div style="margin-left: 4px; font-size: 16px">返回列表</div>
            </div>

            <div class="kp2">{{ cjyhTitle }}</div>

            <div class="content">
              {{ cjyhContent }}
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="kpBox" v-if="kczxShow">
          <div class="kpHead">
            <div>
              <img src="@/assets/indexImg/cjyh.png" alt="安徽继续教育网" />
            </div>
            <div class="kp1">猜你想问</div>
          </div>

          <div class="kp2" v-for="(item,index) in kczx" :key="item.id" @click="showkczx(item)">{{index+1}}.{{ item.title }}</div>
        </div>

        <div class="kpBox1" v-if="!kczxShow">
          <div class="back" @click="kczxShow = true">
            <div class="fleoa">
              <img class="leftImg" src="@/assets/indexImg/left_back.png" alt="安徽继续教育网" />
            </div>
            <div style="margin-left: 4px; font-size: 16px">返回列表</div>
          </div>

          <div class="kp2">{{ kczxTitle }}</div>

          <div class="content">
            {{ kczxContent }}
          </div>
        </div>
      </div>

      <div>
        <div class="kpBox" v-if="jyqbShow">
          <div class="kpHead">
            <div>
              <img src="@/assets/indexImg/cjyh.png" alt="安徽继续教育网" />
            </div>
            <div class="kp1">猜你想问</div>
          </div>

          <div class="kp2" v-for="(item,index) in jyqb" :key="item.id" @click="showjyqb(item)">{{index+1}}.{{ item.title }}</div>
        </div>

        <div class="kpBox1" v-if="!jyqbShow">
          <div class="back" @click="jyqbShow = true">
            <div class="fleoa">
              <img class="leftImg" src="@/assets/indexImg/left_back.png" alt="安徽继续教育网" />
            </div>
            <div style="margin-left: 4px; font-size: 16px">返回列表</div>
          </div>

          <div class="kp2">{{ jyqbTitle }}</div>

          <div class="content">
            {{ jyqbContent }}
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; display: flex; justify-content: center">
      <a
        class="btnShop"
        rel="nofollow"
        target="_blank"
        href="https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136501&language=zh-cn&t=安徽继续教育网"
      >
        <div>其他问题找客服</div>
        <div style="margin-left: 4px"><img src="@/assets/indexImg/jt.png" alt="安徽继续教育网" /></div>
      </a>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      cjyh: [
        {
          title: '集体报名最少多少人？',
          id: 1,
          content: '5 人及以上可走集体报名通道。'
        },
        {
          title: '集体报名有优惠吗？',
          id: 2,
          content: '有，人数越多折扣力度越大，详情请联系客服。'
        },
        {
          title: '报名信息填错了能改吗？',
          id: 3,
          content: '提交后 24 小时内可联系客服修改，超时需重新提交。'
        },
        {
          title: '报名后能调整课程套餐吗？',
          id: 4,
          content: '缴费前可调整，缴费后不支持'
        }
      ],
      kczx: [
        {
          title: '集体报名支持分批缴费吗？',
          id: 5,
          content:
            '不支持，需一次性缴清所有人员费用。'
        },
        {
          title: '报名后多久能开通学习权限？',
          id: 6,
          content:
            '缴费成功后 1-2 个工作日内统一开通。'
        },
        {
          title: '可以指定不同课程给成员吗？',
          id:7,
          content:
            '可以，需在报名表格中备注每人所选课程。'
        },
        {
          title: '集体报名支持对公转账吗？',
          id: 8,
          content:
            '支持，联系客服获取对公账户信息，转账需备注单位名称。'
        }
      ],
      jyqb: [
        {
          title: '发票怎么开？',
          id: 9,
          content:
            '报名成功后在学习中心开具电子发票。'
        },
        {
          title: '成员信息需要逐一上传吗？',
          id: 10,
          content:
            '支持 Excel 批量导入，模板可在页面下载。'
        },
        {
          title: '集体报名有专属客服吗？',
          id: 11,
          content: '有，5 人以上报名将分配专属客服跟进全程。 '
        },
        {
          title: '学习账号是统一发放吗？',
          id: 12,
          content: '是的，开通后会将账号为身份证号码密码默认为身份证后六位'
        }
      ],
      cjyhShow: true,
      cjyhContent: '',
      cjyhTitle: '',
      kczxShow: true,
      kczxContent: '',
      kczxTitle: '',
      jyqbShow: true,
      jyqbContent: '',
      jyqbTitle: '',
      jsczShow: true,
      jsczContent: '',
      jsczTitle: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    showCjyh(item) {
      this.cjyhTitle = item.title;
      this.cjyhContent = item.content;
      this.cjyhShow = false;
    },
    showkczx(item) {
      this.kczxTitle = item.title;
      this.kczxContent = item.content;
      this.kczxShow = false;
    },
    showjyqb(item) {
      this.jyqbTitle = item.title;
      this.jyqbContent = item.content;
      this.jyqbShow = false;
    },
    showjscz(item) {
      this.jsczTitle = item.title;
      this.jsczContent = item.content;
      this.jsczShow = false;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.btnShop {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 52px;
  text-align: center;
  color: #4076f6;
  font-size: 16px;
  font-weight: 500;
  width: 200px;
  height: 48px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid;
  border-image: linear-gradient(97deg, rgba(149, 181, 255, 1), rgba(64, 147, 246, 1)) 1 1;
}
.kpList {
  width: 1400px;

  display: flex;
  justify-content: space-between;
  margin-top: 70px;
  .kpBox {
    width: 430px;
    min-height: 377px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ffffff;
    margin-right: 55px;
    padding: 30px 25px;
    .kpHead {
      display: flex;
      align-items: center;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(64, 118, 246, 0.1);
      .kp1 {
        margin-left: 8px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        margin-bottom: 4px;
      }
    }

    .kp2 {
      padding: 15px 10px;
      width: 100%;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin-top: 10px;
      cursor: pointer;
    }
    .kp2:hover {
      background: rgba(64, 118, 246, 0.15);
      border-radius: 10px 10px 10px 10px;
      color: #4076f6;
    }
  }
  .kpBox1 {
    margin-right: 55px;
    width: 430px;
    min-height: 377px;
    background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
    box-shadow: 0px 5px 20px 0px rgba(113, 114, 117, 0.12);
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ffffff;
    padding: 24px 25px;
    opacity: 0.8;
    .back {
      height: 22px;
      display: flex;
      align-content: center;
      color: #fff;

      cursor: pointer;
      .fleoa {
        position: relative;
        width: 16px;
        height: 16px;
        .leftImg {
          position: absolute;
          top: 2px;
          left: 0;
          width: 16px;
          height: 16px;
        }
      }
    }
    .kp2 {
      margin-top: 15px;
      padding: 15px 10px;
      width: 100%;
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 10px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 10px 10px 10px 10px;
      color: #fff;
    }
    .content {
      margin-top: 20px;
      color: #fff;
      font-size: 16px;
      height: 220px;
      overflow-y: scroll;
    }
    /* 滚动条样式 */
    .content::-webkit-scrollbar {
      width: 1px;
      /*  设置纵轴（y轴）轴滚动条 */
      height: 2px;
      /*  设置横轴（x轴）轴滚动条 */
    }

    /* 滚动条滑块（里面小方块） */
    .content::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background: #fff;
    }

    /* 滚动条轨道 */
    .content::-webkit-scrollbar-track {
      border-radius: 0;
      background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
    }
  }
}
</style>
